import { getColor } from 'common/constants/_colors';
import Text from 'components/base/Text';
import styled from 'styled-components';

const ComingSoonWrapper = styled(Text)`
  background-color: ${getColor('catskillWhite')};
  padding: 0.5rem 0.8rem;
`;

const ComingSoon = () => {
  return (
    <ComingSoonWrapper size='large' mt='0.4rem'>
      Coming soon
    </ComingSoonWrapper>
  );
};

export default ComingSoon;
